import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

interface State {
  userID: string;
  isAuth:boolean;
  otpMethod: string | null;  // SMS or EMAIL
  otpPrompt: string;
  isOtpGenerateAuth:boolean;
  isOtpValidateAuth:boolean;
  isSubscriber: boolean;
  displayTitle: boolean;
}

const store = createStore<State>({
  state: {
    userID: "",
    isAuth:false,
    otpMethod: null,  // Initialize as null
    otpPrompt: "",
    isOtpGenerateAuth:false,
    isOtpValidateAuth:false,
    isSubscriber: false,
    displayTitle: false,
  },
  mutations: {
    setUserID(state, userID: string) {
      state.userID = userID;
    },
    setAuth(state, isAuth: boolean) {
      state.isAuth = isAuth;
    },
    setOtpData(state, { method, prompt }: { method: string, prompt: string }) {
      state.otpMethod = method;
      state.otpPrompt = prompt;
    },
    setOtpGenerateAuth(state, isOtpGenerateAuth: boolean) {
      state.isOtpGenerateAuth = isOtpGenerateAuth;
    },
    setOtpValidateAuth(state, isOtpValidateAuth: boolean) {
      state.isOtpValidateAuth = isOtpValidateAuth;
    },
    setSubscriber(state, isSubscriber: boolean) {
      state.isSubscriber = isSubscriber;
    },
    setDisplayTitle(state, displayTitle: boolean) {
      state.displayTitle = displayTitle;
    },
  },
  plugins: [createPersistedState({ storage: window.localStorage })],
});

export default store;
